// extracted by mini-css-extract-plugin
export default {"Box":"Header_Box__fk4Db","PageTitle":"Header_PageTitle__wopiF","LogoutBox":"Header_LogoutBox__evlLW"};